import { defineBundle, initI18n } from '@frontend-core/i18n';
import en from '../locales/en/shell.json';
import ru from '../locales/ru/shell.json';
import ka from '../locales/ka/shell.json';

const shellBundle = defineBundle('shell', en, ru, ka);
const i18n = initI18n({
  bundles: [shellBundle],
  defaultNS: 'shell',
  detectionOrder: ['querystring', 'navigator'],
});

export default i18n;
